export default {
    state: {
        selectedUserTypesGameAssets: null,
    },
    mutations: {
        SET_USER_TYPES_GAME_ASSETS(state, payload) {
            state.selectedUserTypesGameAssets = payload.selectedUserTypesGameAssets;
        },
    },
    getters: {
        getUserTypesGameAssets: (state) => state.selectedUserTypesGameAssets,
    },
};